import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { toastError } from "../components/ToastError";
import i18n from "../i18n";

export interface IResponse {
  _statusCode: number;
  _message: string;
  _entity: unknown;
  _timeStamp: number;
  _logoLink: string | null;
}

export interface IEdgeCases {
  [key: number]: string;
}

const baseQueryAPI = () => {
  const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders(headers) {
      headers.set(
        "Access-Control-Allow-Origin",
        process.env.REACT_APP_ACL_ORIGIN!
      );
      headers.set("Content-type", "application/json");
      headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE");
      const token = localStorage.getItem("abjadToken");
      headers.set("Authorization", token ?? "");
      return headers;
    },
  });
  const baseQueryExtened: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    const data = result.data as IResponse;
    if (data && data._statusCode === 401) {
      // resetLocalStorage();
      const dir = localStorage.getItem("dir");
      const restoreId = localStorage.getItem("restoreId");
      localStorage.clear();
      if (dir) localStorage.setItem("dir", dir);
      if (restoreId) localStorage.setItem("restoreId", restoreId);
      localStorage.setItem("expired", "true");
      toastError({
        label: i18n.t("error"),
        message: i18n.t("Session Expired"),
        toastId: "session-expired",
        rtl: i18n.dir() === "rtl",
        autoClose: 8000,
      });
      window.location.pathname = "/login";
    }
    const expectedError =
      result.error && result.error.status >= 400 && result.error.status < 500;
    if (result.error && !expectedError) {
      console.log(result.error);
      toastError({
        label: i18n.t("error"),
        message: i18n.t("Technical Erorr"),
        toastId: "technical-issue",
        rtl: i18n.dir() === "rtl",
      });
    }
    return result;
  };
  return baseQueryExtened;
};

export const oneDayDelayProd = 3600;
export const oneDayDelay = 300;
export const API = createApi({
  reducerPath: "api",
  baseQuery: baseQueryAPI(),
  // refetchOnFocus: true,
  refetchOnReconnect: true,
  keepUnusedDataFor:
    process.env.REACT_APP_ENV !== "prod" ? oneDayDelay : oneDayDelayProd,
  tagTypes: ["Assessment", "Notification"],
  endpoints: () => ({}),
});
